// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-wait-container {
  position: absolute;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  top: 0%;
  bottom: auto;
  left: 0%;
  right: auto;
  min-width: 100%;
  min-height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 10000;
}

.spinner-wait {
  position: absolute;
  overflow-y: hidden !important;
  overflow-x: hidden !important;
  top: 10%;
  bottom: auto;
  left: 40%;
  right: auto;
  min-width: 40vh;
  min-height: 40vh;
}

.error-hide {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/auth-callback/auth-callback.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,6BAAA;EACA,6BAAA;EACA,OAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,oCAAA;EACA,cAAA;AACJ;;AACE;EACE,kBAAA;EACA,6BAAA;EACA,6BAAA;EACA,QAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAEJ;;AACE;EACE,aAAA;AAEJ","sourcesContent":[".spinner-wait-container {\n    position: absolute;\n    overflow-y: hidden !important;\n    overflow-x:  hidden !important;\n    top: 0%;\n    bottom:auto;\n    left:0%;\n    right:auto;  \n    min-width: 100%;\n    min-height: 100vh;\n    background-color: rgba(0, 0, 0, 0.3);\n    z-index: 10000;\n  }\n  .spinner-wait {\n    position: absolute;\n    overflow-y: hidden !important;\n    overflow-x:  hidden !important;\n    top: 10%;\n    bottom:auto;\n    left:40%;\n    right:auto;  \n    min-width: 40vh;\n    min-height: 40vh;\n  }\n\n  .error-hide {\n    display: none;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
